import { gql } from 'src/generated/gql';

export const OVERRIDE_VISIT_AUTO_CANCEL_MUTATION = gql(`
  mutation OverrideVisitAutoCancel($eventId: ID!) {
    staff_overrideVisitAutoCancel(eventId: $eventId)
  }
`);
